// extracted by mini-css-extract-plugin
export default {"wrapper":"NoItemCard_wrapper__SQXnY","content":"NoItemCard_content__sCAcQ"};